import React, { useState } from 'react';
import { TagIcon, CopyIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
import { discountOffer } from '../data/product';
export function DiscountSection() {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(discountOffer.code).catch(() => undefined);
    }
    setCopied(true);
  };
  return <section aria-labelledby="discount-heading" className="border-b border-white/10 bg-grit-500" data-id="element-169" data-mp="1cha2w1c2ptkx">
      <div className="mx-auto max-w-[1400px] px-4 py-12 sm:px-6 lg:px-8 lg:py-16" data-id="element-170" data-mp="17jqck323pqcm">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between lg:gap-14" data-id="element-171" data-mp="1m7l8rtfbicug">
          <div data-id="element-172" data-mp="1hgmokir7kulx">
            <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.3em] text-ink-950/70" data-id="element-173" data-mp="1hg3h5vz6pom5">
              <TagIcon className="h-4 w-4" aria-hidden="true" data-id="element-174" data-mp="tpzdjolzxov5" />
              {discountOffer.eyebrow}
            </p>
            <h2 id="discount-heading" className="grit-headline mt-3 text-[clamp(2.5rem,9vw,5rem)] font-extrabold uppercase text-ink-950" data-id="element-175" data-mp="os7dg7b76wfv">
              5 off your first X1.
            </h2>
            <p className="mt-3 max-w-xl text-[15px] font-medium text-ink-950/80 sm:text-base" data-id="element-176" data-mp="2r6i45rlvfgu3">
              {discountOffer.body}
            </p>
          </div>

          <div className="w-full max-w-md shrink-0 bg-ink-950 p-6" data-id="element-177" data-mp="2v7204rupkeen">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-178" data-mp="1yimbcxzfa92l">Your code</p>
            <div className="mt-3 flex items-center justify-between gap-4 border-2 border-dashed border-grit-500 px-4 py-3" data-id="element-179" data-mp="23hp7fsxfd4yf">
              <span className="font-display text-4xl font-extrabold uppercase tracking-[0.12em] text-grit-500" data-id="element-180" data-mp="27gxyur4zsqqt">
                {discountOffer.code}
              </span>
              <button type="button" onClick={handleCopy} className="inline-flex shrink-0 items-center gap-2 bg-grit-500 px-4 py-2.5 font-display text-base font-extrabold uppercase text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px]" data-id="element-181" data-mp="3iwe8xqm4ikgf">
                {copied ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-182" data-mp="1xre35x9lbg6m" /> : <CopyIcon className="h-4 w-4" aria-hidden="true" data-id="element-183" data-mp="1st2v9s2uvfr1" />}
                {copied ? 'Copied' : 'Copy'}
              </button>
            </div>

            <a href="#offer" data-buy-intent="true" className="group mt-5 flex w-full items-center justify-center gap-3 bg-grit-500 px-6 py-4 font-display text-2xl font-extrabold uppercase tracking-wide text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px]" data-id="element-184" data-mp="104owvb7uuhey">
              {discountOffer.cta}
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-185" data-mp="hepa4uzhleep" />
            </a>
            <p className="mt-3 text-[12px] text-steel-500" data-id="element-186" data-mp="2xssq3d4zct9j">{discountOffer.note}</p>
          </div>
        </div>
      </div>
    </section>;
}